import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import moment from "moment-timezone";
import Pagination from "@mui/material/Pagination";
import _ from "lodash";
import { Tooltip, Typography } from "@mui/material";
import "./veyon.scss";
import "react-datepicker/dist/react-datepicker.css";
import DELETE_IMG from "../../globals/assets/stop_vm.png";
import START_IMG from "../../globals/assets/start.svg";
import REFRESH_IMG from "../../globals/assets/refresh.svg";
import CLOSE_IMG from "../../globals/assets/close.svg";
import CALENDER_ICON from "../../globals/assets/Icon metro-calendar (1).svg";
import NOVMFOUND_ICON from "../../globals/assets/noVmFound.svg";
import { getTimezoneOption } from "../../globals/common_utilities/timezoneListing";
import "react-toastify/dist/ReactToastify.css";
import CONSTANTS from "../../globals/common_utilities/constant";
import Dropdown from "../../components/common/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import api_call from "../../globals/common_utilities/axios_old";
import { API, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Z_loader from "../z_index_loader/z_loader";
import ToolTip from "../common/Tooltip";
import Loading from "../loader";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import Cookies from "universal-cookie";
import Veyon_Loader from "../Veyon_loader.js/Veyon_loader";
import ExtendedModal from "../ExtendedModal";
import Button from "../../components/common/Button";
import BreadCrumb from "../../components/BreadCrumb";

const Veyon = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showExtendedModal, setShowExtendedModal] = useState(false);
  const { loginResponse, loading, error } = useSelector((state) => {
    return state.login;
  });
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  const calender_resp = useSelector((state) => {
    return state?.calender_data?.Response?.data;
  });
  const calender_list = calender_resp?.data?.map((e) => {
    return {
      title: e.training.title,
      start: e.start,
      end: e.end,
      id: e.id,
      training_id: e.training_id,
      className:
        e.training.status === "completed"
          ? "spinningColour"
          : e.training.status === "cancelled"
          ? "terminatedColour"
          : e.training.status === "running"
          ? "readyColour"
          : "stoppedColour",
    };
  });
  const [fullCalender, setFullCalender] = useState();

  const [showVeyonScreen, setShowVeyonScreen] = useState(false);
  const [date, setDate] = useState({
    start_date: new Date(),
    end_date: "",
  });
  const [trainingDetails, setTrainingDetails] = useState({
    training_id: "",
    training_name: "",
    selectedEvent: false,
    ID_of_selected_trainig: "",
    zone: "",
  });
  const calender_selected_training_res = useSelector((state) => {
    return state?.calender_selected_training?.Response?.data;
  });

  const [calenderData, setCalenderData] = useState([]);
  const [studentList, setStudentlist] = useState();
  const [selected_training_details, set_selected_training_details] = useState();
  const [selectedTrainingId, SetSelectedTrainingId] = useState({});
  const [student_Details, setStudent_details] = useState();
  const [calenderView, setCalenderView] = useState();
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [resetPassData, setResetPassData] = useState();
  // const [selected_training_details, setSessionData] = useState();
  const [timezonelist, setTimeZonelist] = useState();
  const [veyonImage, setVeyonImage] = useState();
  const [singleVeyonImage, setSingleVeyonImage] = useState();
  const [StudentnameFilter, setStudentnameFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [trainingData, setTrainingData] = useState();
  const [timeZone, setTimeZone] = useState();
  const [tid, setTid] = useState("");
  const [open, setOpen] = useState(false);
  const [showModal, setshowModel] = useState(false);
  const [serverIp, SetServerIp] = useState();
  const [colorStatus, setStatusColor] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [chnageDate, setChangeDate] = useState(new Date());
  const [isLoading, setIsloading] = useState(false);
  const [showveyonLoader, setShowveyonLoader] = useState(false);
  const [multiVeyonToken, setMultiVeyonToken] = useState();
  const [singleVeyonToken, setSingleVeyonToken] = useState();
  const [pageCount, setPageCount] = useState();
  const [offset, setOffset] = useState();
  const datepicker_ref = useRef();
  const calenderRef = useRef();
  const limit = 6;

  useEffect(() => {
    // loadInstructorCalenderData();
    TimeZoneFun();
  }, []);

  useEffect(() => {
    if (date.start_date && date.end_date) {
      loadInstructorCalenderData();
    }
  }, [date.start_date, date.start_date]);

  useEffect(() => {
    if (date.start_date && date.end_date) {
      loadInstructorCalenderData();
    }
  }, [timeZone, statusFilter]);

  useEffect(() => {
    if (trainingDetails?.training_id) {
      getMultipleVeyonToken();
    }
  }, [StudentnameFilter]);

  useEffect(() => {
    loadSessionRelatedData();
    loadSelectedStudent();
    if (calenderView === "timeGridDay") {
      document.getElementById("searchInput").value = "";
    }
    setStudentnameFilter("");
  }, [trainingDetails?.ID_of_selected_trainig]);

  useEffect(() => {
    gotoSpecificDate();
  }, [startDate]);

  useEffect(() => {
    loadSelectedStudent();
  }, [StudentnameFilter]);

  useEffect(() => {
    let intervalId;
    // let gotAllToken =
    //   multiVeyonToken?.data?.filter((data) => {
    //     return data.token === "";
    //   }).length <= 0;

    // if (multiVeyonToken?.status === false && !gotAllToken) {
    //   getMultipleVeyonToken();
    // }
    if (
      showModal === false &&
      selected_training_details?.training?.status === "running" &&
      Array.isArray(multiVeyonToken?.data)
    ) {
      let gotAllToken = multiVeyonToken?.data?.filter((data) => {
        return data.token !== "";
      });
      if (gotAllToken.length > 0) {
        intervalId = setInterval(() => {
          getMultipleVeyonImage();
        }, 10000);
      } else {
        getMultipleVeyonImage();
      }
    }
    if (
      showModal === true &&
      selected_training_details?.training?.status === "running"
    ) {
      if (singleVeyonToken?.data?.token !== "") {
        intervalId = setInterval(() => {
          getSingleVeyonImage();
        }, 5000);
      } else {
        getSingleVeyonImage();
      }
      // return () => {
      //   clearInterval(intervalId);
      // };
    }

    // const intervalTime = setInterval(() => {
    //   let filterData =
    //     Array.isArray(multiVeyonToken?.data) && multiVeyonToken !== undefined
    //       ? multiVeyonToken?.data?.filter((data) => data.token === "")
    //       : [];
    //   if (filterData.length > 0) {
    //     getMultipleVeyonToken();
    //   }
    // }, 5000);
    return () => {
      clearInterval(intervalId);
    };
  }, [multiVeyonToken, singleVeyonToken, showModal]);

  useEffect(() => {
    if (trainingDetails?.training_id) {
      getMultipleVeyonToken();
    }
  }, [student_Details, offset]);

  useEffect(() => {
    let data = calenderData.filter(
      (item) => item.id === trainingDetails.ID_of_selected_trainig
    );
    setTrainingData(data[0]);
  }, [trainingDetails]);
  // useEffect(() => {
  // 	// loadInstructorCalenderData();
  // 	// if (date.start_date) {
  // 	// 	loadInstructorCalenderData();
  // 	// }
  // }, [window.location.pathname]);
  useEffect(() => {
    if (serverIp) getSingleVeyonToken();
  }, [serverIp]);
  // useEffect(() => {
  // if (fullCalender) {
  // 	console.log('full', startDate);
  // 	console.log('fullCalender', fullCalender[0]);
  // }
  // 	if (date?.start_date) {
  // 		console.log('dateSetDate', date?.start_date);
  // 		setStartDate(date?.start_date);
  // 	}
  // }, [date]);

  //   useEffect(() => {
  //     loadInstructorCalenderData();
  //   }, [timeZone, statusFilter]);

  const openDatePicker = () => {
    let ref = datepicker_ref.current.onInputClick();
  };
  const closeModal = () => {
    setShowExtendedModal(false);
  };
  const TimeZoneFun = async () => {
    let timezone = await getTimezoneOption();
    setTimeZonelist(timezone);
  };
  const rescheduleSession = (action) => {
    navigate(APP_ROUTES.ROUTE_CREATESESSION, {
      state: {
        training: selected_training_details.training_id,
        action: action,
      },
    });
  };
  const loadInstructorCalenderData = async (status) => {
    let query =
      role_code === "INSTRUCTOR"
        ? statusFilter
          ? {
              status: statusFilter,
              from_date: date.start_date,
              end_date: date.end_date,
              instructor_id: id,
            }
          : {
              from_date: date.start_date,
              end_date: date.end_date,
              instructor_id: id,
            }
        : statusFilter
        ? {
            status: statusFilter,
            from_date: date.start_date,
            end_date: date.end_date,
          }
        : {
            from_date: date.start_date,
            end_date: date.end_date,
          };
    setIsloading(true);
    const response = await api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.CALENDER
      }`,
      // `${CONSTANTS.API.CALENDER}`,
      query,

      {},
      { zone: timeZone || null }
    ).then((response) => {
      if (response?.data?.data) {
        setCalenderData(() => {
          return response?.data?.data.map((e) => {
            return {
              title: e.training.title,
              start: timeZone
                ? e.start
                : moment(e.start)
                    .add(15, "minutes")
                    .format("YYYY-MM-DD HH:mm:ss"),
              end: timeZone
                ? e.end
                : moment(e.end)
                    .subtract(15, "minutes")
                    .format("YYYY-MM-DD HH:mm:ss"),
              id: e.id,
              training_id: e.training_id,
              status: e.status,
              className:
                e.status === "completed"
                  ? "spinningColour"
                  : e.status === "cancelled"
                  ? "terminatedColour"
                  : e.status === "running"
                  ? "readyColour"
                  : "stoppedColour",
            };
          });
        });
        setIsloading(false);
      } else {
      }
    });
  };

  const loadSessionRelatedData = async (e) => {
    const queryParam =
      role_code === "INSTRUCTOR"
        ? {
            tid: trainingDetails?.training_id || "",
            zone: timeZone || "demo",
            // unique_id: studio_id,
            unique_id: trainingDetails?.ID_of_selected_trainig || "",
            instructor_id: id,
          }
        : role_code === "STUDIO_ADMIN"
        ? {
            tid: trainingDetails?.training_id || "",
            zone: timeZone || "demo",
            // unique_id: studio_id,
            studio_id,
            unique_id: trainingDetails?.ID_of_selected_trainig || "",
          }
        : {
            tid: trainingDetails?.training_id || "",
            zone: timeZone || "demo",
            unique_id: trainingDetails?.ID_of_selected_trainig || "",
          };
    if (trainingDetails?.training_id) {
      const listingResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.CALENDERID
        }`,
        queryParam,
        // `${CONSTANTS.API.CALENDERID}?tid=${
        //   trainingDetails?.ID_of_selected_trainig || ""
        // }&zone=${timeZone || "demo"}`,
        {}
      );
      if (listingResponse.status === STATUS.OK) {
        set_selected_training_details(listingResponse.data.data);
      } else {
        set_selected_training_details([]);
      }
    }
  };

  const loadSelectedStudent = async (e) => {
    let queryParam =
      role_code === "STUDIO_ADMIN"
        ? { studio_id: studio_id }
        : role_code === "INSTRUCTOR"
        ? { instructor_id: id }
        : { instructor_id: id };
    if (trainingDetails?.training_id) {
      const selectedResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.TRAINING
        }/student?tid=${
          trainingDetails?.training_id
        }&is_intrested=Default&name=${StudentnameFilter || ""}`,
        // `${CONSTANTS.API.TRAINING}/student?tid=${
        //   trainingDetails?.training_id
        // }&is_intrested=Default&name=${StudentnameFilter || ""}`,
        queryParam
      );
      const acceptedResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.TRAINING
        }/student?tid=${
          trainingDetails?.training_id
        }&is_intrested=Accepted&name=${StudentnameFilter || ""}`,
        // `${CONSTANTS.API.TRAINING}/student?tid=${
        //   trainingDetails?.training_id
        // }&is_intrested=Accepted&name=${StudentnameFilter || ""}`,
        queryParam
      );

      if (selectedResponse.status === STATUS.OK) {
        let resp = selectedResponse?.data?.data?.rows;
        setStudent_details([
          ...selectedResponse.data.data.rows,
          ...acceptedResponse.data.data.rows,
        ]);
        setPageCount(() =>
          Math.ceil(selectedResponse?.data?.data?.count / limit)
        );

        setStatusColor(() => {
          return resp.map((e) => {
            return {
              className:
                e.status === "pending"
                  ? "pendingstatusDiv"
                  : e.status === "running"
                  ? "runningstatusDiv"
                  : e.status === "completed"
                  ? "completedstatusDiv"
                  : e.status === "stopped"
                  ? "cancelledstatusDiv"
                  : e.status === "cancelled"
                  ? "cancelledstatusDiv"
                  : "pendingstatusDiv",
            };
          });
        });
      } else {
        setStudent_details([]);
      }
    }
  };
  const getMultipleVeyonToken = async () => {
    // if(selected_training_details?.training?.status === "running"){
    setShowveyonLoader(true);
    let name;
    if (StudentnameFilter !== "") {
      name = StudentnameFilter;
    } else {
      name = undefined;
    }
    const response =
      // student_Details.length < 2 && student_Details.length > 0
      //   ? await api_call(
      //       "GET",
      //       CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
      //         API.END_POINTS.VEYON_SINGLEFEED,
      //       {
      //         training_id: trainingDetails?.training_id,
      //         limit: limit || 0,
      //         offset: offset || 0,
      //         server_ip: student_Details[0].public_ip,
      //       }
      //     )
      //   :
      await api_call(
        "GET",
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
          API.END_POINTS.VEYON_MULITFEED,
        {
          training_id: trainingDetails?.training_id,
          name,
          limit: limit || 0,
          offset: offset || 0,
        }
      );
    setVeyonImage([]);
    // if (Array.isArray(response.data)) {
    setMultiVeyonToken(response?.data);
    // } else {
    //   let arrayResponse = [];
    //   setMultiVeyonToken({ data: arrayResponse.push(response?.data) });
    // }
    setShowveyonLoader(false);
  };

  const getSingleVeyonToken = async () => {
    // if(selected_training_details?.training?.status === "running"){

    setShowveyonLoader(true);
    setVeyonImage([]);
    const axios = require("axios");

    const response = await api_call(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
        API.END_POINTS.VEYON_SINGLEFEED,
      { server_ip: serverIp }
    );
    setShowveyonLoader(true);
    if (response.status === 200) {
      setSingleVeyonToken(response.data);
      setShowveyonLoader(false);
    } else {
    }
  };

  const getSingleVeyonImage = async (value) => {
    setShowveyonLoader(true);
    setVeyonImage([]);

    let queryParam = {
      status: singleVeyonToken?.data?.status,
      token: singleVeyonToken?.data?.token,
    };

    const response = await api_call(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
        API.END_POINTS.VEYON_IMAGE_SINGLEFEED,
      queryParam
    );
    setShowveyonLoader(true);
    if (response.status === 200) {
      setSingleVeyonImage(response.data);
      setShowveyonLoader(false);
    } else {
    }
  };

  const getMultipleVeyonImage = async () => {
    setShowveyonLoader(true);

    let body = { data: multiVeyonToken?.data };

    const response = await api_call(
      "POST",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
        API.END_POINTS.VEYON_IMAGE_MULTIFEED,
      {},
      {},
      body
    );
    setVeyonImage(response.data);
    setShowveyonLoader(false);
  };

  const setMulticheckbox = (e) => {
    let value = e.target.value;
    setCheckBoxData((prev) =>
      checkBoxData.includes(value)
        ? prev.filter((cur) => cur !== value)
        : [...prev, value]
    );
  };

  const resetPassfun = async () => {
    var now = moment().utcOffset(0, true).format();
    var startTime = moment(selected_training_details?.session_start_date);
    var startTimeDif = startTime.diff(now, "minutes");
    var endTime = moment(selected_training_details?.session_end_date);
    var endTimeDif = endTime.diff(now, "minutes");

    let body = {
      user_training_id: checkBoxData,
      training_id: selected_training_details?.training_id,
    };
    setIsloading(true);
    if (checkBoxData.length === 0) {
      setIsloading(false);
      toast.error("please select VM to reset", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      return;
    }

    if (true) {
      let queryparams =
        role_code === "STUDIO_ADMIN"
          ? { studio_id: studio_id }
          : role_code === "INSTRUCTOR"
          ? { instructor_id: id }
          : "";
      setResetPassData(checkBoxData);
      const response = await api_call(
        "POST",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.RESET_PASSWORD
        }`,
        // `${CONSTANTS.API.RESET_PASSWORD}`,
        queryparams,
        {},
        body
      );
      if (response.status === 200) {
        // window.reload();
        setIsloading(false);
        loadSelectedStudent();
        toast.success(
          "Password has been reset successfully. You will receive mail in 15 Minutes",
          {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          }
        );
      } else {
        setIsloading(false);
        toast.error(`You can Reset Password only ongoing Trainings`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      }
    }
  };

  //   const deleteStudent = async (data) => {
  //     let ID = localStorage.getItem("USER_ID");
  //     let response = "";
  //     if (localStorage.getItem("ROLE_CODE") === ROLE.ADMIN) {
  //       response = await api_call(
  //         "POST",
  //         `${CONSTANTS.API.TRAINING}/delete `,
  //         {},
  //         {},
  //         {
  //           status: CONSTANTS.CONSTANTS_DATA.CANCLE,
  //           training_id: data?.training_id,
  //           cancel_by: ID,
  //           reason: "test",
  //         }
  //       );
  //     } else if (
  //       localStorage.getItem("ROLE_CODE") === ROLE.STUDIO_ADMIN
  //     ) {
  //       response = await api_call(
  //         "POST",
  //         `${CONSTANTS.API.TRAINING_STUDIO_ADMIN}/delete `,
  //         {},
  //         {},
  //         {
  //           status: CONSTANTS.CONSTANTS_DATA.CANCLE,
  //           training_id: data?.training_id,
  //           cancel_by: ID,
  //           reason: "test",
  //         }
  //       );
  //     } else if (
  //       localStorage.getItem("ROLE_CODE") === ROLE.INSTRUCTOR
  //     ) {
  //       response = await api_call(
  //         "POST",
  //         `${CONSTANTS.API.TRAINING_INSTRUCTOR}/delete `,
  //         {},
  //         {},
  //         {
  //           status: CONSTANTS.CONSTANTS_DATA.CANCLE,
  //           training_id: data?.training_id,
  //           cancel_by: ID,
  //           reason: "test",
  //         }
  //       );
  //     }
  //     if (response.status === STATUS.OK) {
  //       loadSelectedStudent();
  //       loadSessionRelatedData();
  //     }
  //   };

  const onTimeZoneChange = (e) => {
    let data1 = e?.value?.split("$");
    setTimeZone(data1[0]);
  };

  const gotoSpecificDate = (date) => {
    let calendarApi = calenderRef.current.getApi();
    calendarApi.gotoDate(startDate);
  };

  const startServer = async (
    training_id,
    studentId,
    studio_id,
    instructor_id,
    indexValue
  ) => {
    if (selected_training_details?.training?.status === "running") {
      if (role_code === ROLE.ADMIN) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STARTSERVER
          }`,
          // CONSTANTS.API.STARTSERVER,
          {},
          {},
          {
            training_id: training_id,
            student_id: studentId,
          }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server started successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      } else if (role_code === ROLE.STUDIO_ADMIN) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STARTSERVER
          }`,
          // CONSTANTS.API.STARTSERVER,
          { studio_id: studio_id },
          {},
          {
            training_id: training_id,
            student_id: studentId,
          }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server started successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      } else if (role_code === ROLE.INSTRUCTOR) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STARTSERVER
          }`,
          // CONSTANTS.API.STARTSERVER,
          { instructor_id: instructor_id },
          {},
          {
            training_id: training_id,
            student_id: studentId,
          }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server started successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      }
    } else {
      toast.error("The Session is not in Running stage", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };

  const stopServer = async (
    training_id,
    studentId,
    studio_id,
    instructor_id,
    indexValue
  ) => {
    if (selected_training_details?.training?.status === "running") {
      if (role_code === ROLE.ADMIN) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STOPSERVER
          }`,
          // CONSTANTS.API.STOPSERVER,
          { restart: false },
          {},
          { training_id: training_id, student_id: studentId }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server stopped successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      } else if (role_code === ROLE.STUDIO_ADMIN) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STOPSERVER
          }`,
          // CONSTANTS.API.STOPSERVER,
          { restart: false, studio_id: studio_id },
          {},
          { training_id: training_id, student_id: studentId }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server stopped successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            background: "#FFFFFF",
          });
        }
      } else if (role_code === ROLE.INSTRUCTOR) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STOPSERVER
          }`,
          // CONSTANTS.API.STOPSERVER,
          { restart: false, instructor_id: instructor_id },
          {},
          { training_id: training_id, student_id: studentId }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server stopped successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            background: "#FFFFFF",
          });
        }
      }
    } else {
      toast.error("The Session is not in Running stage", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };

  const restartServer = async (
    training_id,
    studentId,
    studio_id,
    instructor_id
  ) => {
    if (selected_training_details?.training?.status === "running") {
      if (role_code === ROLE.ADMIN) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STOPSERVER
          }`,
          // CONSTANTS.API.STOPSERVER,
          {
            restart: true,
          },
          {},
          { training_id: training_id, student_id: studentId }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server restarted successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      } else if (role_code === ROLE.STUDIO_ADMIN) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STOPSERVER
          }`,
          // CONSTANTS.API.STOPSERVER,
          { restart: true, studio_id: studio_id },
          {},
          { training_id: training_id, student_id: studentId }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server restarted successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      } else if (role_code === ROLE.INSTRUCTOR) {
        const response = await api_call(
          "POST",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
            API.END_POINTS.STOPSERVER
          }`,
          // CONSTANTS.API.STOPSERVER,
          { restart: true, instructor_id: instructor_id },
          {},
          { training_id: training_id, student_id: studentId }
        );
        if (response.status === STATUS.OK) {
          toast.success("Server restarted successfully", {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else if (response.status === STATUS.BAD_REQUEST) {
          toast.error(response.err.data.msg, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        }
      }
    } else {
      toast.error("The Session is not in Running stage", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };

  const statusChange = (
    training_id,
    studentId,
    studio_id,
    instructor_id,
    indexValue,
    status
  ) => {
    if (selected_training_details?.training?.status === "running") {
      if (status === "stopped") {
        toast.error("Please wait till the VM get Updated", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        startServer(
          training_id,
          studentId,
          studio_id,
          instructor_id,
          indexValue
        );
      } else if (status === "running") {
        toast.error("Please wait till the VM get Updated", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          background: "#FFFFFF",
        });
        stopServer(
          training_id,
          studentId,
          studio_id,
          instructor_id,
          indexValue
        );
      }
    } else {
      toast.error("The Session is not in Running stage", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    }
  };

  const onPageClickhandler = (e, data) => {
    setOffset(Math.ceil((data - 1) * limit));
  };

  const onCloseModal = () => {
    setShowExtendedModal(false);
  };
  const handleVeyonClose = () => {
    setshowModel(false);
    setSingleVeyonImage("");
  };
  const createSession = () => {
    navigate(APP_ROUTES.ROUTE_CREATESESSION, { state: {} });
  };
  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  };
  return (
    <>
      <Box className="higherMainContainer">
        <Box className="searchContainer">
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              {/* <Typography variant="h6" className="dashboard_heading">
                Training
              </Typography> */}
              {/* <BreadCrumb value="Trainings" /> */}
              <span className="larger_f_bold">Training</span>
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              {/* <Button value="View All Training" role="default" /> */}
              <button
                className="view_all_training_style"
                onClick={() => navigate("/training")}
              >
                View All Training
              </button>
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <Box className="item2 ">
                <button className="cursor_" onClick={createSession}>
                  Create Session
                </button>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Grid container columnSpacing={2} className="maincontainer">
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={
              calenderView ? (calenderView === "timeGridDay" ? 4.5 : 12) : 4.5
            }
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="calenderComponent"
            >
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                className="veyonTimezone"
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={
                    calenderView
                      ? calenderView === "timeGridDay"
                        ? 12
                        : 6
                      : 12
                  }
                  lg={
                    calenderView
                      ? calenderView === "timeGridDay"
                        ? 12
                        : 4
                      : 12
                  }
                >
                  <Dropdown
                    placeholder="Timezone"
                    selection
                    clearable
                    onChange={(e) => onTimeZoneChange(e)}
                    options={timezonelist}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} className="calenderBox">
                {calenderView ? (
                  calenderView == "dayGridMonth" ||
                  calenderView == "timeGridWeek" ? (
                    ""
                  ) : (
                    <Grid item xs={12}>
                      <Box className="veyonDatePicker">
                        <span className="alignDatePicker">
                          <DatePicker
                            ref={datepicker_ref}
                            closeOnScroll={true}
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            onSelect={gotoSpecificDate}
                            dateFormat="MMMM d, yyyy"
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        </span>

                        <img src={CALENDER_ICON} onClick={openDatePicker} />
                      </Box>
                    </Grid>
                  )
                ) : (
                  <Grid item xs={12}>
                    <Box className="veyonDatePicker">
                      <span className="alignDatePicker">
                        <DatePicker
                          ref={datepicker_ref}
                          closeOnScroll={true}
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          onSelect={gotoSpecificDate}
                          dateFormat="MMMM d, yyyy"
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                        />
                      </span>

                      <img src={CALENDER_ICON} onClick={openDatePicker} />
                    </Box>
                  </Grid>
                )}

                <Grid className="fullcalenderDiv">
                  <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    id={"id"}
                    ref={calenderRef}
                    headerToolbar={{
                      left: "",
                      center: "",
                      // right: 'prev,next,timeGridDay,timeGridWeek,dayGridMonth',
                      right: "timeGridDay,timeGridWeek,dayGridMonth",
                    }}
                    initialView="timeGridDay"
                    editable={true}
                    events={calenderData}
                    datesSet={(dateInfo) => {
                      // setStartDate(dateInfo.start);
                      setDate({
                        start_date: moment(dateInfo.start)
                          .subtract(1, "day")
                          .format("YYYY-MM-DD"),
                        end_date: moment(dateInfo.end)
                          .subtract(1, "day")
                          .format("YYYY-MM-DD"),
                      });
                    }}
                    selectable={true}
                    selectMirror={true}
                    eventOverlap={false}
                    slotEventOverlap={false}
                    selectOverlap={false}
                    dayMaxEvents={true}
                    eventClick={(e) => {
                      if (calenderView === "timeGridDay") {
                        setTrainingDetails({
                          ...trainingDetails,
                          training_id: e.event.extendedProps.training_id,
                          ID_of_selected_trainig: e.event.id,
                          selectedEvent: true,
                        });
                        setMultiVeyonToken([]);
                      }
                    }}
                    eventsSet={(e) => {
                      setFullCalender(e);
                      setCalenderView(e[0]?._context?.currentViewType);
                      set_selected_training_details([]);
                      setTrainingDetails("");
                      setShowVeyonScreen(false);
                    }}
                    slotDuration="01:00:00"
                    slotMinutes="30"
                    eventDisplay="block"
                    snapDuration="1:00:00"
                    dayMaxEventRows={2}
                    selectHelper="true"
                    timeZone="UTC"
                    allDaySlot={false}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                columnSpacing={2}
                className="veyonbuttonTopMargin"
              >
                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <div
                    className="item3"
                    onClick={() => setStatusFilter("running")}
                  >
                    Running
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <div
                    className="item1"
                    onClick={() => setStatusFilter("pending")}
                  >
                    Pending
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <div
                    className="item2"
                    onClick={() => setStatusFilter("completed")}
                  >
                    Completed
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <div
                    className="item4"
                    onClick={() => setStatusFilter("cancel")}
                  >
                    Terminated
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {calenderView ? (
            calenderView === "timeGridDay" ? (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={
                  calenderView
                    ? calenderView === "timeGridDay"
                      ? 7.5
                      : 12
                    : 7.5
                }
              >
                <Grid className="veyonComponent">
                  <Box className="veyonContainer">
                    <Grid container>
                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Box className="SessionName">
                          <Tooltip
                            title={selected_training_details?.training?.title}
                            placement="top-start"
                            arrow
                          >
                            <div className="verticalAlign">
                              {selected_training_details?.training?.title
                                ? add3Dots(
                                    selected_training_details?.training?.title,
                                    20
                                  )
                                : ""}
                              {/* {selected_training_details?.training?.title} */}
                            </div>
                          </Tooltip>
                        </Box>
                      </Grid>
                      {!showVeyonScreen &&
                        role_code === "INSTRUCTOR" &&
                        selected_training_details?.training?.status ===
                          "running" && (
                          <Grid item xs={12} sm={2} md={2} lg={2}>
                            <Link
                              target="_blank"
                              to={`//${
                                selected_training_details?.training
                                  ? selected_training_details?.training?.host.replace(
                                      /^https?:\/\//,
                                      ""
                                    )
                                  : ""
                              }`}
                            >
                              <Box className="veyonresetAlign">
                                <span
                                  className="veyonResetPassContainer"
                                  // onClick={resetPassfun}
                                >
                                  Join
                                </span>
                              </Box>
                            </Link>
                          </Grid>
                        )}

                      {selected_training_details?.training?.cloud_type ===
                      "AWS" ? (
                        !showVeyonScreen &&
                        role_code === "INSTRUCTOR" &&
                        selected_training_details?.training?.status ===
                          "running" ? (
                          <Grid item xs={12} sm={3} md={3} lg={3}>
                            <Box className="veyonresetAlign">
                              <span
                                className="veyonResetPassContainer"
                                onClick={() => setShowExtendedModal(true)}
                              >
                                Extend Training
                              </span>
                            </Box>
                          </Grid>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      {selected_training_details?.training?.cloud_type === "AWS"
                        ? !showVeyonScreen &&
                          selected_training_details?.training?.status ==
                            "pending" && (
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                              <Box className="veyonresetAlign">
                                <span
                                  className="veyonResetPassContainer"
                                  onClick={() =>
                                    rescheduleSession("reschedule")
                                  }
                                >
                                  Reschedule
                                </span>
                              </Box>
                            </Grid>
                          )
                        : ""}
                      {selected_training_details?.training?.cloud_type === "AWS"
                        ? !showVeyonScreen &&
                          selected_training_details?.training?.status ==
                            "in-progress" && (
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                              <Box className="veyonresetAlign">
                                <span
                                  className="veyonResetPassContainer"
                                  onClick={() =>
                                    rescheduleSession("reschedule")
                                  }
                                >
                                  Reschedule
                                </span>
                              </Box>
                            </Grid>
                          )
                        : ""}
                      {selected_training_details?.training?.cloud_type === "AWS"
                        ? !showVeyonScreen &&
                          trainingData?.status === "running" && (
                            <Grid item xs={12} sm={3} md={3} lg={3}>
                              <Box className="veyonresetAlign">
                                <span
                                  className="veyonResetPassContainer"
                                  onClick={resetPassfun}
                                >
                                  Reset Password
                                </span>
                              </Box>
                            </Grid>
                          )
                        : ""}
                    </Grid>
                  </Box>
                  <Box className="veyonContainer">
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box className="veyonsearchInputLong">
                          <input
                            type="text"
                            placeholder="Search"
                            id="searchInput"
                            onChange={
                              // (e) => setStudentnameFilter(e.target.value)
                              (e) => {
                                if (!e.target.value) {
                                  return setStudentnameFilter("");
                                }
                                const debouncedFilter = _.debounce(() => {
                                  setStudentnameFilter(e.target.value);
                                }, 1000);
                                debouncedFilter();
                              }
                            }
                          />
                          <i className="fa fa-search"></i>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {/* {selected_training_details?.training?.cloud_type ===
                        "AWS" ? ( */}
                        <Box className="veyonToggelalignItem">
                          <label className="switch btn-color-mode-switch">
                            <input
                              type="checkbox"
                              name="color_mode"
                              id="color_mode"
                              onClick={() =>
                                setShowVeyonScreen(!showVeyonScreen)
                              }
                            />
                            <label
                              htmlFor="color_mode"
                              data-on="Veyon"
                              data-off="VM List"
                              className="btn-color-mode-switch-inner cursor_"
                            ></label>
                          </label>
                        </Box>
                        {/* ) : (
                          ""
                        )} */}
                      </Grid>
                    </Grid>
                  </Box>
                  {selected_training_details?.training?.title ? (
                    <>
                      {!showVeyonScreen && (
                        <Box className="veyonContainer">
                          <Grid container className="veyonheadingGrid">
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={4}
                              className="item"
                            >
                              Student Name
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={4}
                              className="item"
                            >
                              DNS
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={2}
                              className="item"
                            >
                              Status
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={2}
                              className="item"
                            >
                              Action
                            </Grid>
                          </Grid>
                          <Box className="veyonlistGridContainer">
                            {student_Details?.length > 0 ? (
                              student_Details.map((ele, indexValue) => {
                                return (
                                  <Grid container className="veyonListing">
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={4}
                                      className="item1"
                                      container
                                      alignItems={"centre"}
                                    >
                                      <input
                                        type="checkbox"
                                        value={ele?.id}
                                        onClick={(e) => setMulticheckbox(e)}
                                        className="alignCheckbox"
                                      />
                                      <span className="studentName">
                                        {ele?.student?.name}
                                      </span>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={4}
                                      className="item2 setPaddingUrl"
                                    >
                                      <div style={{ margin: "0px 10px" }}>
                                        <a
                                          className="urlText"
                                          // href={ele?.virtual_machine_url}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {ele?.virtual_machine_url}
                                        </a>
                                      </div>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={2}
                                      className="item2"
                                    >
                                      {ele?.status === "pending" && (
                                        <span className="pendingstatusDiv">
                                          {ele?.status}
                                        </span>
                                      )}
                                      {ele?.status === "initializing" && (
                                        <span className="runningstatusDiv">
                                          {ele?.status}
                                        </span>
                                      )}
                                      {ele?.status === "running" && (
                                        <span className="runningstatusDiv">
                                          {ele?.status}
                                        </span>
                                      )}
                                      {ele?.status === "completed" && (
                                        <span className="completedstatusDiv">
                                          {ele?.status}
                                        </span>
                                      )}
                                      {(ele?.status === "stopped" ||
                                        ele?.status === "cancelled") && (
                                        <span className="cancelledstatusDiv">
                                          {ele?.status}
                                        </span>
                                      )}
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={2}
                                      className={
                                        ele?.is_machine_required === true
                                          ? "item3 "
                                          : "item3  set-opacity"
                                      }
                                      container
                                      justifyContent={"space-evenly"}
                                      alignItems={"center"}
                                    >
                                      {selected_training_details?.training
                                        ?.cloud_type === "AWS" &&
                                      ele.status !== "stopped" ? (
                                        <ToolTip
                                          title={"restart"}
                                          placement="right"
                                          arrow={true}
                                          content={
                                            <img
                                              src={REFRESH_IMG}
                                              onClick={() =>
                                                restartServer(
                                                  ele?.training_id,
                                                  ele?.student_id,
                                                  ele?.student?.studio_id,
                                                  id,
                                                  indexValue,
                                                  "restart"
                                                )
                                              }
                                              disabled={
                                                ele?.status !== "running" ||
                                                ele?.is_machine_required ===
                                                  false
                                              }
                                            />
                                          }
                                        ></ToolTip>
                                      ) : (
                                        ""
                                      )}
                                      <ToolTip
                                        title={
                                          ele?.status === "running"
                                            ? "Stop VM"
                                            : "Start VM"
                                        }
                                        placement="right"
                                        arrow={true}
                                        content={
                                          <img
                                            src={
                                              ele?.status === "running"
                                                ? DELETE_IMG
                                                : START_IMG
                                            }
                                            style={{
                                              height: "40px",
                                              width: "40px",
                                            }}
                                            onClick={() =>
                                              statusChange(
                                                ele?.training_id,
                                                ele?.student_id,
                                                ele?.student?.studio_id,
                                                id,
                                                indexValue,
                                                ele?.status
                                              )
                                            }
                                            disabled={
                                              ele?.status !== "running" ||
                                              ele?.is_machine_required === false
                                            }
                                          />
                                        }
                                      ></ToolTip>
                                    </Grid>
                                  </Grid>
                                );
                              })
                            ) : (
                              <Grid className="noVmFound">
                                <img
                                  src={NOVMFOUND_ICON}
                                  width="50%"
                                  height="50%"
                                />
                                <p>No student added in Training</p>
                              </Grid>
                            )}
                          </Box>
                        </Box>
                      )}
                      {
                        showVeyonScreen &&
                          (showveyonLoader ? (
                            selected_training_details?.training?.cloud_type ===
                            "AWS" ? (
                              <Veyon_Loader />
                            ) : (
                              <Veyon_Loader />
                            )
                          ) : // selected_training_details?.training?.cloud_type ===
                          //   "AWS" ? (
                          StudentnameFilter ? (
                            student_Details.length === 0 ? (
                              <Typography
                                width="100%"
                                height="210px"
                                className="image-text-align"
                              >
                                Student not found
                              </Typography>
                            ) : (
                              <Box className="veyonContainer">
                                {selected_training_details?.training?.status ===
                                "running" ? (
                                  veyonImage?.status === true ? (
                                    <Grid
                                      container
                                      spacing={2}
                                      className="veyonListingContainer"
                                    >
                                      {veyonImage?.data.map((data, i) => {
                                        return (
                                          <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Box
                                              className="imageDiv"
                                              key={data?.selectedDateTrainingId}
                                              onClick={
                                                data?.image
                                                  ? () => {
                                                      SetServerIp(data.ip);
                                                      setshowModel(true);
                                                    }
                                                  : ""
                                              }
                                            >
                                              {data?.image ? (
                                                <img
                                                  src={
                                                    "data:image/image/png;base64," +
                                                    data?.image
                                                  }
                                                  width="100%"
                                                  height="210px"
                                                />
                                              ) : (
                                                <Typography
                                                  width="100%"
                                                  height="210px"
                                                  className="image-text-align"
                                                >
                                                  VM is offline
                                                </Typography>
                                              )}

                                              <Box className="imageDetails">
                                                <Box className="imagePadding small_f">
                                                  <span>
                                                    Student Name :{" "}
                                                    {data?.studentName}
                                                  </span>
                                                </Box>
                                                <Box className="imagePadding small_f">
                                                  <span>
                                                    DNS URL:
                                                    {data?.virtual_machine_url}
                                                  </span>
                                                </Box>
                                              </Box>
                                            </Box>
                                          </Grid>
                                        );
                                      })}
                                      {/* <Grid container justifyContent={'end'}>
                                    <Grid item>
                                      <Pagination
                                        count={pageCount}
                                        onChange={onPageClickhandler}
                                      />
                                    </Grid>
                                  </Grid> */}
                                    </Grid>
                                  ) : (
                                    // (
                                    setShowveyonLoader(true)
                                    // (
                                    // 	<Grid justifyContent={'end'}>
                                    // 		<Grid item>
                                    // 			<Pagination
                                    // 				count={pageCount}
                                    // 				onChange={onPageClickhandler}
                                    // 			/>
                                    // 		</Grid>
                                    // 	</Grid>
                                    // )
                                    // )
                                  )
                                ) : (
                                  <>
                                    <Grid className="noVmFound">
                                      <img
                                        src={NOVMFOUND_ICON}
                                        width="50%"
                                        height="50%"
                                      />
                                      <p>Session is Stopped</p>
                                    </Grid>
                                  </>
                                )}
                                {/* <Grid
                              display={'flex'}
                              justifyContent={'end'}
                              alignItems="flex-end"
                            >
                              <Grid item>
                                <Pagination
                                  count={pageCount}
                                  onChange={onPageClickhandler}
                                />
                              </Grid>
                            </Grid> */}
                                {/* {veyonImage?.status === true ? (
                              
                            ) : (
                              ""
                            )} */}
                              </Box>
                            )
                          ) : (
                            <Box className="veyonContainer">
                              {selected_training_details?.training?.status ===
                              "running" ? (
                                veyonImage?.status === true ? (
                                  <Grid
                                    container
                                    spacing={2}
                                    className="veyonListingContainer"
                                  >
                                    {veyonImage?.status &&
                                      veyonImage?.data.map((data, i) => {
                                        return (
                                          <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                          >
                                            <Box
                                              className="imageDiv"
                                              key={data?.selectedDateTrainingId}
                                              onClick={
                                                data?.image
                                                  ? () => {
                                                      SetServerIp(data.ip);
                                                      setshowModel(true);
                                                    }
                                                  : ""
                                              }
                                            >
                                              {data?.image ? (
                                                <img
                                                  src={
                                                    "data:image/image/png;base64," +
                                                    data?.image
                                                  }
                                                  width="100%"
                                                  height="210px"
                                                />
                                              ) : (
                                                <Typography
                                                  width="100%"
                                                  height="210px"
                                                  className="image-text-align"
                                                >
                                                  VM is offline
                                                </Typography>
                                              )}

                                              <Box className="imageDetails">
                                                <Box className="imagePadding small_f">
                                                  <span>
                                                    Student Name :{" "}
                                                    {data?.studentName}
                                                  </span>
                                                </Box>
                                                <Box className="imagePadding small_f">
                                                  <span>
                                                    DNS URL :
                                                    {data?.virtual_machine_url}
                                                  </span>
                                                </Box>
                                              </Box>
                                            </Box>
                                          </Grid>
                                        );
                                      })}
                                    {/* <Grid container justifyContent={'end'}>
																	<Grid item>
																		<Pagination
																			count={pageCount}
																			onChange={onPageClickhandler}
																		/>
																	</Grid>
																</Grid> */}
                                  </Grid>
                                ) : (
                                  // (
                                  setShowveyonLoader(true)
                                  // (
                                  // 	<Grid justifyContent={'end'}>
                                  // 		<Grid item>
                                  // 			<Pagination
                                  // 				count={pageCount}
                                  // 				onChange={onPageClickhandler}
                                  // 			/>
                                  // 		</Grid>
                                  // 	</Grid>
                                  // )
                                  // )
                                )
                              ) : (
                                <>
                                  <Grid className="noVmFound">
                                    <img
                                      src={NOVMFOUND_ICON}
                                      width="50%"
                                      height="50%"
                                    />
                                    <p>Session is Stopped</p>
                                  </Grid>
                                </>
                              )}
                              {/* <Grid
														display={'flex'}
														justifyContent={'end'}
														alignItems="flex-end"
													>
														<Grid item>
															<Pagination
																count={pageCount}
																onChange={onPageClickhandler}
															/>
														</Grid>
													</Grid> */}
                              {/* {veyonImage?.status === true ? (
                            
                          ) : (
                            ""
                          )} */}
                            </Box>
                          ))
                        // ) : (
                        //   <Typography
                        //     width="100%"
                        //     height="210px"
                        //     className="image-text-align"
                        //   >
                        //     Veyon is not available for GCP sessions
                        //   </Typography>
                        // )
                      }
                    </>
                  ) : (
                    <Grid className="noVmFound">
                      <img src={NOVMFOUND_ICON} width="50%" height="50%" />
                      <p>please select any session to view details</p>
                    </Grid>
                  )}
                  {showModal && (
                    <div id="myModal" className="veyonImageModal">
                      <div
                        className={
                          singleVeyonImage?.data?.image
                            ? "veyonImageModal-content"
                            : "veyon_header_loader"
                        }
                      >
                        <img
                          src={CLOSE_IMG}
                          onClick={() => handleVeyonClose()}
                        />
                        {singleVeyonImage?.data?.image ? (
                          <img
                            src={
                              "data:image/image/png;base64," +
                              singleVeyonImage?.data?.image
                            }
                            width="100%"
                            height="95%"
                          />
                        ) : (
                          <p>Loading Please wait ...</p>
                        )}
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>
            ) : (
              ""
            )
          ) : (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={
                calenderView ? (calenderView === "timeGridDay" ? 7.5 : 12) : 7.5
              }
            >
              <Grid className="veyonComponent">
                <Box className="veyonContainer">
                  <Grid container>
                    <Grid item xs={12} sm={4} md={4} lg={4}>
                      <Box className="SessionName">
                        <Tooltip
                          title={selected_training_details?.training?.title}
                          placement="top-start"
                          arrow
                        >
                          <div className="verticalAlign">
                            {/* {add3Dots(
                              selected_training_details?.training?.title,
                              20
                            )} */}
                            {selected_training_details?.training?.title}
                          </div>
                        </Tooltip>
                      </Box>
                    </Grid>
                    {!showVeyonScreen &&
                      role_code === "INSTRUCTOR" &&
                      selected_training_details?.training?.status ===
                        "running" && (
                        <Grid item xs={12} sm={2} md={2} lg={2}>
                          <Link
                            target="_blank"
                            to={`//${
                              selected_training_details?.training
                                ? selected_training_details?.training?.host.replace(
                                    /^https?:\/\//,
                                    ""
                                  )
                                : ""
                            }`}
                          >
                            <Box className="veyonresetAlign">
                              <span
                                className="veyonResetPassContainer"
                                // onClick={resetPassfun}
                              >
                                Join
                              </span>
                            </Box>
                          </Link>
                        </Grid>
                      )}
                    {!showVeyonScreen &&
                    role_code === "INSTRUCTOR" &&
                    selected_training_details?.training?.status ===
                      "running" ? (
                      <Grid item xs={12} sm={3} md={3} lg={3}>
                        <Box className="veyonresetAlign">
                          <span
                            className="veyonResetPassContainer"
                            onClick={() => setShowExtendedModal(true)}
                          >
                            Extend Training
                          </span>
                        </Box>
                      </Grid>
                    ) : (
                      ""
                    )}

                    {selected_training_details?.training?.cloud_type === "AWS"
                      ? !showVeyonScreen &&
                        selected_training_details?.training?.status ===
                          "running" && (
                          <Grid item xs={12} sm={3} md={3} lg={3}>
                            <Box className="veyonresetAlign">
                              <span
                                className="veyonResetPassContainer"
                                onClick={resetPassfun}
                              >
                                Reset Password
                              </span>
                            </Box>
                          </Grid>
                        )
                      : ""}

                    {!showVeyonScreen &&
                      selected_training_details?.training?.status ==
                        "pending" && (
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box className="veyonresetAlign">
                            <span
                              className="veyonResetPassContainer"
                              onClick={() => rescheduleSession("reschedule")}
                            >
                              Reschedule
                            </span>
                          </Box>
                        </Grid>
                      )}
                    {!showVeyonScreen &&
                      selected_training_details?.training?.status ==
                        "in-progress" && (
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Box className="veyonresetAlign">
                            <span
                              className="veyonResetPassContainer"
                              onClick={() => rescheduleSession("reschedule")}
                            >
                              Reschedule
                            </span>
                          </Box>
                        </Grid>
                      )}
                  </Grid>
                </Box>
                <Box className="veyonContainer">
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="veyonsearchInputLong">
                        <input
                          type="text"
                          placeholder="Search"
                          id="searchInput"
                          onChange={(e) => {
                            if (!e.target.value)
                              return setStudentnameFilter("");

                            const debouncedFilter = _.debounce(() => {
                              setStudentnameFilter(e.target.value);
                            }, 1000);
                            debouncedFilter();
                          }}
                        />
                        <i className="fa fa-search"></i>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      {selected_training_details?.training?.cloud_type ===
                      "AWS" ? (
                        <Box className="veyonToggelalignItem">
                          <label className="switch btn-color-mode-switch">
                            <input
                              type="checkbox"
                              name="color_mode"
                              id="color_mode"
                              onClick={() =>
                                setShowVeyonScreen(!showVeyonScreen)
                              }
                            />
                            <label
                              htmlFor="color_mode"
                              data-on="Veyon"
                              data-off="VM List"
                              className="btn-color-mode-switch-inner cursor_"
                            ></label>
                          </label>
                        </Box>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </Box>
                {selected_training_details?.training?.title ? (
                  <>
                    {!showVeyonScreen && (
                      <Box className="veyonContainer">
                        <Grid container className="veyonheadingGrid">
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            className="item"
                          >
                            Student Name
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            className="item"
                          >
                            DNS
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={2}
                            className="item"
                          >
                            Status
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={2}
                            className="item"
                          >
                            Action
                          </Grid>
                        </Grid>
                        <Box className="veyonlistGridContainer">
                          {student_Details?.length > 0 ? (
                            student_Details.map((ele, indexValue) => {
                              return (
                                <Grid container className="veyonListing">
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={4}
                                    className="item1"
                                    container
                                    alignItems={"centre"}
                                  >
                                    <input
                                      type="checkbox"
                                      value={ele?.id}
                                      onClick={(e) => setMulticheckbox(e)}
                                      className="alignCheckbox"
                                    />
                                    <span className="studentName">
                                      {ele?.student?.name}
                                    </span>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={4}
                                    className="item2 setPaddingUrl"
                                  >
                                    <div style={{ margin: "0px 10px" }}>
                                      <a
                                        className="urlText"
                                        // href={ele?.virtual_machine_url}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {ele?.virtual_machine_url}
                                      </a>
                                    </div>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={2}
                                    className="item2"
                                  >
                                    {ele?.status === "pending" && (
                                      <span className="pendingstatusDiv">
                                        {ele?.status}
                                      </span>
                                    )}
                                    {ele?.status === "initializing" && (
                                      <span className="runningstatusDiv">
                                        {ele?.status}
                                      </span>
                                    )}
                                    {ele?.status === "running" && (
                                      <span className="runningstatusDiv">
                                        {ele?.status}
                                      </span>
                                    )}
                                    {ele?.status === "completed" && (
                                      <span className="completedstatusDiv">
                                        {ele?.status}
                                      </span>
                                    )}
                                    {(ele?.status === "stopped" ||
                                      ele?.status === "cancelled") && (
                                      <span className="cancelledstatusDiv">
                                        {ele?.status}
                                      </span>
                                    )}
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={2}
                                    className={
                                      ele?.is_machine_required === true
                                        ? "item3 "
                                        : "item3  set-opacity"
                                    }
                                    container
                                    justifyContent={"space-evenly"}
                                    alignItems={"center"}
                                  >
                                    {selected_training_details?.training
                                      ?.cloud_type === "AWS" ? (
                                      <ToolTip
                                        title={"restart"}
                                        placement="right"
                                        arrow={true}
                                        content={
                                          <img
                                            src={REFRESH_IMG}
                                            onClick={() =>
                                              ele?.status !== "running"
                                                ? ""
                                                : restartServer(
                                                    ele?.training_id,
                                                    ele?.student_id,
                                                    ele?.student?.studio_id,
                                                    id,
                                                    indexValue,
                                                    "restart"
                                                  )
                                            }
                                            disabled={ele?.status !== "running"}
                                          />
                                        }
                                      ></ToolTip>
                                    ) : (
                                      ""
                                    )}

                                    <ToolTip
                                      title={
                                        ele?.status === "running"
                                          ? "Stop VM"
                                          : "Start VM"
                                      }
                                      placement="right"
                                      arrow={true}
                                      content={
                                        <img
                                          src={
                                            ele?.status === "running"
                                              ? DELETE_IMG
                                              : START_IMG
                                          }
                                          style={{
                                            height: "40px",
                                            width: "40px",
                                          }}
                                          onClick={() =>
                                            ele?.status !== "running"
                                              ? ""
                                              : statusChange(
                                                  ele?.training_id,
                                                  ele?.student_id,
                                                  ele?.student?.studio_id,
                                                  id,
                                                  indexValue,
                                                  ele?.status
                                                )
                                          }
                                          disabled={ele?.status !== "running"}
                                        />
                                      }
                                    ></ToolTip>
                                  </Grid>
                                </Grid>
                              );
                            })
                          ) : (
                            <Grid className="noVmFound">
                              <img
                                src={NOVMFOUND_ICON}
                                width="50%"
                                height="50%"
                              />
                              <p>No student added in Training</p>
                            </Grid>
                          )}
                        </Box>
                      </Box>
                    )}
                    {showVeyonScreen &&
                      (showveyonLoader ? (
                        <Veyon_Loader />
                      ) : (
                        <Box className="veyonContainer">
                          {selected_training_details?.training?.status ===
                          "running" ? (
                            veyonImage?.status === true ? (
                              <Grid
                                container
                                spacing={2}
                                className="veyonListingContainer"
                              >
                                {veyonImage?.status &&
                                  veyonImage?.data.map((data, i) => {
                                    return (
                                      <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <Box
                                          className="imageDiv"
                                          key={data?.selectedDateTrainingId}
                                          onClick={
                                            data?.image
                                              ? () => {
                                                  SetServerIp(data.ip);
                                                  setshowModel(true);
                                                }
                                              : ""
                                          }
                                        >
                                          {data?.image ? (
                                            <img
                                              src={
                                                "data:image/image/png;base64," +
                                                data?.image
                                              }
                                              width="100%"
                                              height="210px"
                                            />
                                          ) : (
                                            <Typography
                                              width="100%"
                                              height="210px"
                                              className="image-text-align"
                                            >
                                              VM is offline
                                            </Typography>
                                          )}

                                          <Box className="imageDetails">
                                            <Box className="imagePadding small_f">
                                              <span>
                                                Student Name :{" "}
                                                {data?.studentName}
                                              </span>
                                            </Box>
                                            <Box className="imagePadding small_f">
                                              <span>
                                                DNS URL :
                                                {data?.virtual_machine_url}
                                              </span>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </Grid>
                                    );
                                  })}
                                {/* <Grid container justifyContent={'end'}>
																	<Grid item>
																		<Pagination
																			count={pageCount}
																			onChange={onPageClickhandler}
																		/>
																	</Grid>
																</Grid> */}
                              </Grid>
                            ) : (
                              // (
                              setShowveyonLoader(true)
                              // (
                              // 	<Grid justifyContent={'end'}>
                              // 		<Grid item>
                              // 			<Pagination
                              // 				count={pageCount}
                              // 				onChange={onPageClickhandler}
                              // 			/>
                              // 		</Grid>
                              // 	</Grid>
                              // )
                              // )
                            )
                          ) : (
                            <>
                              <Grid className="noVmFound">
                                <img
                                  src={NOVMFOUND_ICON}
                                  width="50%"
                                  height="50%"
                                />
                                <p>Session is Stopped</p>
                              </Grid>
                            </>
                          )}
                          {/* <Grid
														display={'flex'}
														justifyContent={'end'}
														alignItems="flex-end"
													>
														<Grid item>
															<Pagination
																count={pageCount}
																onChange={onPageClickhandler}
															/>
														</Grid>
													</Grid> */}
                          {/* {veyonImage?.status === true ? (
                            
                          ) : (
                            ""
                          )} */}
                        </Box>
                      ))}
                  </>
                ) : (
                  <Grid className="noVmFound">
                    <img src={NOVMFOUND_ICON} width="50%" height="50%" />
                    <p>please select any session to view details</p>
                  </Grid>
                )}
                {showModal && (
                  <div id="myModal" className="veyonImageModal">
                    <div
                      className={
                        singleVeyonImage?.data?.image
                          ? "veyonImageModal-content"
                          : "veyon_header_loader"
                      }
                    >
                      <img src={CLOSE_IMG} onClick={() => handleVeyonClose()} />
                      {singleVeyonImage?.data?.image ? (
                        <img
                          src={
                            "data:image/image/png;base64," +
                            singleVeyonImage?.data?.image
                          }
                          width="100%"
                          height="95%"
                        />
                      ) : (
                        <p>Loading Please wait ...</p>
                      )}
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>
      {showVeyonScreen ? (
        <Grid display={"flex"} justifyContent={"end"} alignItems="flex-end">
          <Grid item>
            <Pagination count={pageCount} onChange={onPageClickhandler} />
          </Grid>
        </Grid>
      ) : (
        ""
      )}
      {isLoading && <MultiLine_Spinner />}
      {showExtendedModal && (
        <ExtendedModal
          closeModal={() => closeModal()}
          training_id={selected_training_details.training_id}
          training_date_id={selected_training_details.id}
        />
      )}

      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default Veyon;
